import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function TreatmentsCTA() {
  return <section className="bg-[#FF1493] py-[48px] lg:py-[80px]" data-id="element-2192">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2193">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-2194">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-2195">
            NOT SURE WHICH TREATMENT IS RIGHT FOR YOU?
          </h2>

          <p className="font-serif italic text-white/90 text-lg lg:text-xl mb-10" data-id="element-2196">
            Book a complimentary consultation and let our experts create a
            personalized treatment plan
          </p>

          <Button variant="white" size="lg" className="w-full sm:w-auto px-10 py-4 text-sm tracking-[2px] rounded uppercase text-[#FF1493] hover:bg-black hover:text-white transition-colors" data-id="element-2197">
            BOOK CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}